import React from "react";
import moment from "moment";
import { MdFileDownload } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { CREATED, DELETED } from "../../../utils/constants";
const DownloadContainer = ({ digitalIdentity, history }) => {
  // Function to convert JSON to CSV
  const jsonToCSV = (history) => {
    const keys = [
      "Controller",
      "Customer Scope",
      "Type",
      "Value",
      "Record Type",
      "ID Type",
      "ID Value",
      "Created Date",
      "Deletd Date",
      "Time Zone",
    ];

    // CSV rows initialization
    const csvRows = [];

    // Add the header row
    csvRows.push(keys.join(","));

    // Now process the rest of your history data
    history.forEach((row) => {
      const values = [
        digitalIdentity?.controller_code || "",
        digitalIdentity?.customer_scope || "",
        digitalIdentity?.type || "",
        digitalIdentity?.value || "",
        row?.identity || "",
        row?.type || "",
        row?.value || "",
        row?.valid_from
          ? moment.utc(row?.valid_from).local().format("DD.MM.YYYY HH:mm")
          : "",
        row?.valid_to
          ? moment.utc(row?.valid_to).local().format("DD.MM.YYYY HH:mm")
          : "",
        "UTC" + moment().format("Z"),
      ];
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  };

  const groupHistory = (data) => {
    const grouped = {};
    // Group by type + value
    data?.forEach((item) => {
      const key = `${item.type}|${item.value}`;
      if (!grouped[key]) {
        grouped[key] = {
          type: item?.type,
          value: item?.value,
          identity: item?.identity,
          valid_from: "",
          valid_to: "",
        };
      }
      if (item.action === CREATED) {
        grouped[key].valid_from = item?.dateTime;
      } else if (item.action === DELETED) {
        grouped[key].valid_to = item?.dateTime;
      }
    });
    return Object.values(grouped);
  };

  const downloadCSV = () => {
    const groupedHistory = groupHistory(history);
    const csv = jsonToCSV(groupedHistory);
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().replace(/[-T:.]/g, "");
    link.download = `${"subIdentity_alias_history"}-${formattedDate}.csv`;
    link.click();

    window.URL.revokeObjectURL(url);
  };
  return (
    <div
      role="button"
      className="d-flex justify-content-end align-items-center history-download-btn"
      onClick={downloadCSV}
    >
      <MdFileDownload size={22} />
      <span className="px-1">
        <FormattedMessage
          id="label.subidentityAliasesHistory"
          defaultMessage="Download history"
        />
      </span>
    </div>
  );
};

export default DownloadContainer;
